import { PRIVATE } from '@/plugins/acl/const'
import comingSoonRoute from '@/router/utils/comingSoonRoute'

const panel = [
  {
    path: '/dashboard/',
    name: 'panel-dashboard',
    component: () => import('@/views/panel/dashboard/Dashboard.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.DASHBOARD,
    },
  },
  {
    path: '/reminders/',
    name: 'panel-reminders',
    component: () => import('@/views/panel/reminders/RemindersList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.REMINDERS,
    },
  },
  comingSoonRoute({
    path: '/ai-assistant/',
    name: 'panel-ai-assistant',
    comingSoonKey: 'aiAssistant',
    resource: PRIVATE.AI_ASSISTANT,
  }),
]

export default panel
